import React, { useState, useMemo } from 'react';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import { modalType } from '@24i/player-ui';
import SingleRow from '@24i/nxg-sdk-gluons/src/components/containers/SingleRow/index.web';
import getSingleRowStyles from '@24i/nxg-sdk-gluons/src/components/containers/SingleRow/styles/index.web';
import Packshot from '@24i/nxg-sdk-gluons/src/components/ui/Packshot/index.web';
import getPackshotStyles from '@24i/nxg-sdk-gluons/src/components/ui/Packshot/styles/index.web';
import { defaultRenderProgressBar } from '@24i/nxg-sdk-gluons/src/components/ui/Packshot/components';
import ModalPicker from '@24i/nxg-sdk-gluons/src/components/inputs/ModalPicker';
import useContinueWatchingQuery from '@24i/nxg-sdk-smartott/src/hooks/query/continueWatching/useContinueWatchingQuery';
import { useTheme } from '@24i/nxg-sdk-higgs/src/hooks/useTheme';
import { useRouter } from '@24i/nxg-core-router/src/NextRouter';
import { SOTT_DEFAULT_WEB_SCREENS } from '@24i/nxg-sdk-smartott/src/navigation/constants';
import { CloseButton } from '../../components/CloseButton';
import { Container, PackshotHolder, SingleRowContainer, getSeasonPickerStyles, } from './styled';
const PACKSHOT_WIDTH = 248;
const PACKSHOT_HEIGHT = 139;
export const EpisodesModal = ({ className = '', playerInstance, seriesData, }) => {
    const { t } = useTranslation(['sott']);
    const router = useRouter();
    const { data: continueWatchingPlaylist } = useContinueWatchingQuery();
    const [selectedSeason, setSelectedSeason] = useState(null);
    const progress = useMemo(() => {
        if (!playerInstance) {
            return 0;
        }
        const { currentTime, duration } = playerInstance;
        return currentTime / duration;
    }, []);
    const { seasons } = seriesData;
    const currentSeason = selectedSeason
        ? seasons[selectedSeason]
        : seasons.find(({ isCurrent }) => isCurrent);
    const { episodes } = currentSeason;
    const { currentEpisode } = seriesData;
    const { theme } = useTheme();
    const styles = getSeasonPickerStyles(theme);
    return (React.createElement(Container, { className: `Episodes-Modal ${className}` },
        React.createElement(CloseButton, { type: modalType.episodes, testID: "close_episodes_button", styles: {
                top: -60,
            } }),
        seasons.length > 1 && !!currentSeason.name && (React.createElement(ModalPicker, { selectedValue: currentSeason.name, options: seasons.map((item) => item.name), onValueChange: (index) => setSelectedSeason(index), color: theme.color.textPrimary, theme: theme, additionalContainerStyles: styles.pickerContainer, additionalTextStyles: styles.pickerText, optionsContainerStyles: styles.optionsContainer, viewContainerStyles: styles.viewContainer, isModalOnOpen: false, isDropdown: true, focusEnabled: true, returnIndex: true, iconSize: 20 })),
        React.createElement(SingleRowContainer, null,
            React.createElement(SingleRow, { title: t('player.miniEpg.allEpisodes'), showDuration: true, testId: "episodes", onItemPress: (asset, event) => {
                    const eventAsEvent = event;
                    const { type, id } = asset;
                    if (eventAsEvent.preventDefault)
                        eventAsEvent.preventDefault();
                    if (eventAsEvent.stopPropagation)
                        eventAsEvent.stopPropagation();
                    if (id === currentEpisode.id)
                        return;
                    const assetLink = SOTT_DEFAULT_WEB_SCREENS.Playback.getLink({
                        type,
                        id,
                    });
                    router.replace({
                        pathname: assetLink.href,
                    }, assetLink.as);
                }, packshotHeight: PACKSHOT_HEIGHT, packshotWidth: PACKSHOT_WIDTH, key: "episodesAssetsRow", section: {
                    items: episodes,
                }, styles: (propsTheme) => {
                    const singleRowStyles = getSingleRowStyles(propsTheme, true);
                    return Object.assign(Object.assign({}, singleRowStyles), { container: Object.assign(Object.assign({}, singleRowStyles.container), { width: '100%', marginHorizontal: 'auto', overflow: 'visible' }) });
                }, renderPackshot: (props) => {
                    const isCurrentlyPlaying = props.item.id === currentEpisode.id;
                    let itemProgress = 0;
                    if (!isEmpty(continueWatchingPlaylist)) {
                        const cwAsset = continueWatchingPlaylist.find((asset) => asset.id === props.item.id);
                        itemProgress =
                            cwAsset && cwAsset.continueWatchingOffset && cwAsset.duration
                                ? cwAsset.continueWatchingOffset / cwAsset.duration
                                : undefined;
                    }
                    return (React.createElement(PackshotHolder, { isCurrentlyPlaying },
                        React.createElement(Packshot, Object.assign({}, props, { testID: `episode_${props.index}_tile`, styles: (propsTheme) => {
                                const packshotStyles = getPackshotStyles(propsTheme);
                                return Object.assign(Object.assign({}, packshotStyles), { item: Object.assign(Object.assign({}, packshotStyles.item), { overflow: 'visible' }) });
                            }, progress: isCurrentlyPlaying ? progress : itemProgress, actionIcon: !isCurrentlyPlaying ? 'play' : undefined, title: `${props.item.episodeNumber}. ${props.item.title}`, renderProgressBar: defaultRenderProgressBar }))));
                } }))));
};
//# sourceMappingURL=index.js.map